import { getClient } from '@/api/api-client';
import type { RentIndexLookupResult } from '@condo/domain';

export const getRentIndex = async (mfhId: number): Promise<RentIndexLookupResult> =>
    getClient('basecamp')
        .get<RentIndexLookupResult>(`/mfh/${mfhId}/finance/investment-cases/rent-index-lookup`)
        .then(response => response.data);
